import React from "react";
import IconBase from "./IconBase";

const Scatter = (props: any) => {
  return (
    <IconBase viewBox="0 0 32 32" {...props} stroke="currentColor" strokeWidth="2">
      <path d="M29.375 28.375H5.062c-.75 0-1.438-.625-1.438-1.375V2.625c0-.563-.438-1-1-1s-1 .438-1 1V27c0 1.875 1.5 3.375 3.438 3.375h24.375c.563 0 1-.438 1-1s-.5-1-1.063-1zm-18.437-6.312c0 1-.813 1.75-1.75 1.75s-1.75-.75-1.75-1.75c0-.938.813-1.688 1.75-1.688s1.75.75 1.75 1.688zm6.312-9.25c0 1-.75 1.75-1.75 1.75-.938 0-1.688-.75-1.688-1.75 0-.938.75-1.688 1.688-1.688 1 0 1.75.75 1.75 1.688zm2.188 6.812c0 1-.75 1.75-1.688 1.75-1 0-1.75-.75-1.75-1.75 0-.938.75-1.688 1.75-1.688.938 0 1.688.75 1.688 1.688zm4.875-5.562c0 .938-.75 1.688-1.75 1.688-.938 0-1.688-.75-1.688-1.688s.75-1.75 1.688-1.75c1 0 1.75.813 1.75 1.75zM27 7.5c0 .938-.813 1.688-1.75 1.688S23.5 8.438 23.5 7.5s.813-1.75 1.75-1.75S27 6.563 27 7.5z" />
    </IconBase>
  );
};

export default Scatter;
